/**
 * Customer Reviews Slider
 * For comparison article pages
 */

document.addEventListener('DOMContentLoaded', function() {
  const sliderContainers = document.querySelectorAll('.comparison-article-container .customer-reviews-slider');
  
  sliderContainers.forEach(function(container) {
    initSlider(container);
  });
  
  function initSlider(container) {
    const images = Array.from(container.querySelectorAll('img'));
    
    if (images.length <= 1) return; // No need for slider if only one image
    
    // Create track (viewport with overflow hidden)
    const track = document.createElement('div');
    track.className = 'customer-reviews-slider-track';
    
    // Create wrapper for slides (this will move)
    const wrapper = document.createElement('div');
    wrapper.className = 'customer-reviews-slider-wrapper';
    
    // Wrap each image in a slide div for better control
    images.forEach(img => {
      const slide = document.createElement('div');
      slide.className = 'slider-slide';
      slide.appendChild(img);
      wrapper.appendChild(slide);
    });
    
    track.appendChild(wrapper);
    container.innerHTML = '';
    container.appendChild(track);
    
    // Create navigation buttons
    const prevBtn = createNavButton('prev');
    const nextBtn = createNavButton('next');
    container.appendChild(prevBtn);
    container.appendChild(nextBtn);
    
    // Create dots
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'slider-dots';
    
    images.forEach((_, index) => {
      const dot = document.createElement('span');
      dot.className = 'slider-dot' + (index === 0 ? ' active' : '');
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });
    
    container.appendChild(dotsContainer);
    
    let currentSlide = 0;
    const slides = wrapper.querySelectorAll('.slider-slide');
    
    function createNavButton(direction) {
      const button = document.createElement('button');
      button.className = `slider-nav ${direction}`;
      button.setAttribute('aria-label', direction === 'prev' ? 'Previous slide' : 'Next slide');
      
      const svg = direction === 'prev' 
        ? '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>'
        : '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>';
      
      button.innerHTML = svg;
      button.addEventListener('click', () => {
        if (direction === 'prev') {
          prevSlide();
        } else {
          nextSlide();
        }
      });
      
      return button;
    }
    
    function updateSlider() {
      // Simple: move by 100% per slide
      wrapper.style.transform = `translateX(-${currentSlide * 100}%)`;
      
      // Update dots
      const dots = dotsContainer.querySelectorAll('.slider-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentSlide);
      });
    }
    
    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      updateSlider();
    }
    
    function prevSlide() {
      currentSlide = (currentSlide - 1 + slides.length) % slides.length;
      updateSlider();
    }
    
    function goToSlide(index) {
      currentSlide = index;
      updateSlider();
    }
    
    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    container.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });
    
    function handleSwipe() {
      if (touchEndX < touchStartX - 50) {
        nextSlide();
      }
      if (touchEndX > touchStartX + 50) {
        prevSlide();
      }
    }
    
    // Keyboard navigation
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
      }
    });
  }
});

